import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a 1.8-metre walnut church pew on 2x1 tiles: bench seat
// at 0.45, full back, solid end panels and a low kneeler rail in front (+Z).
const WOOD = "#7a5a3a";
const WOOD_DARK = "#6b4e33";

export const churchPew = defineModel({
  id: "church-pew",
  batchId: "modern",
  name: "Church pew",
  tags: ["modern", "interior", "furniture", "church", "seating", "pew"],
  summary: "A walnut church pew with a full back and kneeler rail.",
  tiles: { w: 2, h: 1 },
  footprint: 1.3,
  parts(): Part[] {
    return [
      // solid end panels
      { geometry: new THREE.BoxGeometry(0.05, 0.9, 0.56), color: WOOD_DARK, position: [-0.875, 0.45, -0.05] },
      { geometry: new THREE.BoxGeometry(0.05, 0.9, 0.56), color: WOOD_DARK, position: [0.875, 0.45, -0.05] },
      // bench seat (top at 0.45)
      { geometry: new THREE.BoxGeometry(1.7, 0.06, 0.42), color: WOOD, position: [0, 0.42, 0.02] },
      // seat support box
      { geometry: new THREE.BoxGeometry(1.7, 0.14, 0.34), color: WOOD_DARK, position: [0, 0.32, 0.0] },
      // full back, slightly reclined
      { geometry: new THREE.BoxGeometry(1.7, 0.58, 0.05), color: WOOD, position: [0, 0.72, -0.24], rotation: [-0.1, 0, 0] },
      // top back rail
      { geometry: new THREE.BoxGeometry(1.7, 0.06, 0.09), color: WOOD_DARK, position: [0, 1.0, -0.27] },
      // kneeler rail low in front
      { geometry: new THREE.BoxGeometry(1.6, 0.05, 0.16), color: WOOD, position: [0, 0.13, 0.4] },
      { geometry: new THREE.BoxGeometry(0.05, 0.11, 0.12), color: WOOD_DARK, position: [-0.7, 0.055, 0.4] },
      { geometry: new THREE.BoxGeometry(0.05, 0.11, 0.12), color: WOOD_DARK, position: [0.7, 0.055, 0.4] },
    ];
  },
  animations: [],
});
